module.exports = __webpack_public_path__ + "img/item2.1a2720f6.png";